export default "__VITE_ASSET__BhyFlh2X__"